import { useState } from "react";
import SelectDropdown from "../../../shared/components/SelectDropdown";
import DateTimePicker from "../../../shared/components/DateTimePicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX } from "@fortawesome/free-solid-svg-icons";
import { colors } from "../../../global";

export default function Filter({ title }) {
  const [filters, setFilters] = useState({
    companyName: "",
    rateCardName: [],
    carrierName: "",
    carrierService: "",
    rateCardType: "1",
    latestVersion: true,
    rateCardVersion: "",
    dateRange: { from: "2019-05-18", to: "2025-05-23" },
    from: "",
    to: "",
    calculationType: "",
  });

  // Sample options
  const companyOptions = [
    { value: "company1", label: "Company 1" },
    { value: "company2", label: "Company 2" },
    { value: "company3", label: "Company 3" },
  ];

  const rateCardOptions = [
    { value: "card1", label: "Rate Card 1" },
    { value: "card2", label: "Rate Card 2" },
    { value: "card3", label: "Rate Card 3" },
    { value: "card4", label: "Rate Card 4" },
    { value: "card5", label: "Rate Card 5" },
    { value: "card6", label: "Rate Card 6" },
  ];

  const carrierOptions = [
    { value: "carrier1", label: "Carrier 1" },
    { value: "carrier2", label: "Carrier 2" },
  ];

  const serviceOptions = [
    { value: "service1", label: "Service 1" },
    { value: "service2", label: "Service 2" },
  ];

  const versionOptions = [
    { value: "v1", label: "Version 1.0" },
    { value: "v2", label: "Version 2.0" },
  ];

  const calculationOptions = [
    { value: "calc1", label: "Calculation Type 1" },
    { value: "calc2", label: "Calculation Type 2" },
  ];

  const clearAllFilters = () => {
    setFilters({
      companyName: "",
      rateCardName: [],
      carrierName: "",
      carrierService: "",
      rateCardType: "1",
      latestVersion: true,
      rateCardVersion: "",
      dateRange: { from: "", to: "" },
      from: "",
      to: "",
      calculationType: "",
    });
  };

  return (
    <>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-semibold" style={{ color: colors.primary }}>
          Filters
        </h2>
        <button
          onClick={clearAllFilters}
          className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800 bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors duration-200 flex items-center gap-2"
        >
          <FontAwesomeIcon icon={faX} className="w-4 h-4" />
          Clear all filters
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-6">
        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            Company Name
          </label>
          <SelectDropdown
            options={companyOptions}
            placeholder="All"
            value={filters.companyName}
            onChange={(value) =>
              setFilters((prev) => ({ ...prev, companyName: value }))
            }
          />
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            RateCard Name
          </label>
          <SelectDropdown
            options={rateCardOptions}
            placeholder="Multiple selections"
            isMulti={true}
            value={filters.rateCardName}
            onChange={(value) =>
              setFilters((prev) => ({ ...prev, rateCardName: value }))
            }
          />
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            Carrier Name
          </label>
          <SelectDropdown
            options={carrierOptions}
            placeholder="All"
            value={filters.carrierName}
            isMulti={true}
            onChange={(value) =>
              setFilters((prev) => ({ ...prev, carrierName: value }))
            }
          />
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            CarrierService
          </label>
          <SelectDropdown
            options={serviceOptions}
            placeholder="All"
            value={filters.carrierService}
            onChange={(value) =>
              setFilters((prev) => ({ ...prev, carrierService: value }))
            }
          />
        </div>

        <div className="space-y-2">
          <label
            className="block text-sm font-medium"
            style={{ color: colors.accent }}
          >
            RatecardType
          </label>
          <SelectDropdown
            options={[
              { value: "1", label: "1" },
              { value: "2", label: "2" },
              { value: "3", label: "3" },
            ]}
            placeholder="1"
            value={filters.rateCardType}
            onChange={(value) =>
              setFilters((prev) => ({ ...prev, rateCardType: value }))
            }
          />
        </div>

        <div className="space-y-2">
          <label
            className="block text-sm font-medium"
            style={{ color: colors.accent }}
          >
            LatestVersion
          </label>
          <SelectDropdown
            options={[
              { value: true, label: "True" },
              { value: false, label: "False" },
            ]}
            placeholder="True"
            value={filters.latestVersion}
            onChange={(value) =>
              setFilters((prev) => ({ ...prev, latestVersion: value }))
            }
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6 mt-6">
        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            RatecardVersion
          </label>
          <SelectDropdown
            options={versionOptions}
            placeholder="All"
            value={filters.rateCardVersion}
            onChange={(value) =>
              setFilters((prev) => ({ ...prev, rateCardVersion: value }))
            }
          />
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            RCV - DateCreated
          </label>
          <div className="flex gap-2">
            <DateTimePicker
              selected={filters.dateRange.from}
              onChange={(date) =>
                setFilters((prev) => ({
                  ...prev,
                  dateRange: { ...prev.dateRange, from: date },
                }))
              }
              placeholder="From date"
            />
            <DateTimePicker
              selected={filters.dateRange.to}
              onChange={(date) =>
                setFilters((prev) => ({
                  ...prev,
                  dateRange: { ...prev.dateRange, to: date },
                }))
              }
              placeholder="To date"
            />
          </div>
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            From
          </label>
          <SelectDropdown
            options={[]}
            placeholder="All"
            value={filters.from}
            onChange={(value) =>
              setFilters((prev) => ({ ...prev, from: value }))
            }
          />
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">To</label>
          <SelectDropdown
            options={[]}
            placeholder="All"
            value={filters.to}
            onChange={(value) => setFilters((prev) => ({ ...prev, to: value }))}
          />
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            CalculationType
          </label>
          <SelectDropdown
            options={calculationOptions}
            placeholder="All"
            value={filters.calculationType}
            onChange={(value) =>
              setFilters((prev) => ({ ...prev, calculationType: value }))
            }
          />
        </div>
      </div>
    </>
  );
}
